
import React, { useMemo } from "react";
import Particles from "react-tsparticles";

function isMobile() {
  if (typeof window !== "undefined") {
    return window.innerWidth <= 767;
  }
  return false;
}

function Particle() {
  const mobile = useMemo(() => isMobile(), []);
  const particleParams = useMemo(() => ({
    particles: {
      number: {
        value: mobile ? 60 : 160,
        density: {
          enable: true,
          value_area: mobile ? 600 : 1500,
        },
      },
      line_linked: {
        enable: false,
        opacity: 0.03,
      },
      move: {
        direction: "right",
        speed: 0.05,
      },
      size: {
        value: 1,
      },
      opacity: {
        anim: {
          enable: true,
          speed: 1,
          opacity_min: 0.05,
        },
      },
    },
    interactivity: {
      events: {
        onclick: {
          enable: true,
          mode: "push",
        },
      },
      modes: {
        push: {
          particles_nb: 1,
        },
      },
    },
    retina_detect: true,
  }), [mobile]);

  return (
    <Particles
      id="tsparticles"
      params={particleParams}
      style={{ width: '100vw', height: '100vh', maxWidth: '100%', maxHeight: '100%', position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 0 }}
    />
  );
}

export default Particle;
